import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { supabase } from '../supabase/supabase';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);

    // Check auth state for conditional login/dashboard button
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      subscription.unsubscribe();
    };
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'py-4' : 'py-8'}`}>
      <div className="max-w-[1600px] mx-auto px-8 flex items-center justify-between">
        <Link to="/" className="flex items-center group">
          <span className="text-2xl font-black tracking-tighter text-white uppercase hover:text-stark-pink transition-colors">stark</span>
        </Link>
        
        <div className="hidden md:flex items-center gap-1 bg-white/5 backdrop-blur-xl border border-white/10 rounded-full p-1 shadow-2xl">
          <a href="#work" className="px-6 py-2 text-sm font-bold hover:text-stark-pink transition-colors">Showcase</a>
          <div className="w-[1px] h-4 bg-white/10 mx-1" />
          
          {user ? (
            <Link to="/dashboard" className="px-6 py-2 text-sm font-bold text-stark-lime hover:text-white transition-colors flex items-center gap-2">
              <SafeIcon icon={FiIcons.FiGrid} /> DASHBOARD
            </Link>
          ) : (
            <Link to="/login" className="px-6 py-2 text-sm font-bold hover:text-stark-pink transition-colors">
              Login
            </Link>
          )}
          
          <div className="w-[1px] h-4 bg-white/10 mx-1" />
          <Link 
            to="/start" 
            className="px-6 py-2 bg-stark-lime text-black rounded-full text-sm font-black hover:bg-white transition-all duration-300 flex items-center gap-2"
          >
            START PROJECT <SafeIcon icon={FiIcons.FiArrowUpRight} />
          </Link>
        </div>

        <button className="md:hidden w-12 h-12 glass-card rounded-full flex items-center justify-center">
          <SafeIcon icon={FiIcons.FiMenu} className="text-xl" />
        </button>
      </div>
    </nav>
  );
}